 <script>
  import Timeline from 'src/pc/pages/Timeline'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Timeline,
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer
    },
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .timeline {
    top: 0 !important;
  }
  .timeline .title {
    width: 100vw;
    margin-bottom: 30px;
  }
  .timeline .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .timeline .title_top:before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .timeline .title_top p {
    font-size: 34px;
  }
  .timeline .list {
    margin-top: -10px;
  }
  .timeline .list .timeline_results .regions {
    margin-left: -15px;
    top: 60px;
    bottom: 0;
    width: 100vw;
    height: 50px;
    margin-bottom: -35px;
  }
  .timeline .list .timeline_results .regions div {
    display: inline-block;
    width: 50%;
    height: 100%;
    text-align: center;
  }
  .timeline .list .timeline_results .regions .asia {
    padding-right: 20px;
  }
  .timeline .list .timeline_results .regions .am-eu {
    padding-left: 20px;
  }
  .timeline .list .timeline_results .regions div p {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.04em;
    padding: 15px 0;
    margin-top: 2px;
  }
  .timeline .list .title_wrap {
    top: 70px;
  }
  .timeline .list h3 {
    width: 70px;
    height: 70px;
    font-size: 13px;
    font-weight: 600;
    border: 0;
    margin: 0 0 20px 0;
    line-height: 1.35em;
  }
  .timeline .list h3 p {
    font-size: 15px;
  }
  .timeline .list h3 .month {
    font-size: 18px;
  }
  .timeline .list .timeline_wrap:before,
  .timeline .list .timeline_wrap:after {
    width: 3px;
  }
  .timeline .list .ctnr_wrap:before {
    width: 16px;
    height: 16px;
    border-width: 5px;
  }
  .timeline .list .timeline_ctnr,
  .timeline .list .timeline_ctnr.am-eu {
    display: inherit;
    padding: 15px 8px;
    text-align: center;
  }
  .timeline .list .timeline_ctnr:after {
    width: 10px;
    height: 10px;
    top: 50%;
    right: -5px;
    transform: rotate(45deg) translate(-50%,-50%);
  }
  .timeline .list .timeline_ctnr.am-eu:after {
    left: -5px;
  }
  .timeline .list .timeline_ctnr .ongo,
  .timeline .list .timeline_ctnr.am-eu .ongo {
    font-size: 10px;
    position: relative;
    top: unset;
    left: unset;
    right: unset;
    padding: 4px 7px;
    margin-bottom: 10px;
    width: max-content;
  }
	.timeline .list .timeline_ctnr .brand {
    position: relative;
    width: 100%;
    right: unset;
    text-align: center;
    padding: 30px 0 12px;
    z-index: 1;
  }
	.timeline .list .timeline_ctnr.am-eu .brand {
    left: unset;
  }
	.timeline .list .timeline_ctnr .brand .img {
    display: inline-block;
    width: 16vw;
		height: 16vw;
    background: #000;
    border-radius: 4px;
  }
	.timeline .list .timeline_ctnr .brand .img:after {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }
	.timeline .list .timeline_ctnr .cont,
	.timeline .list .timeline_ctnr.am-eu .cont {
    position: static;
    width: 100%;
		padding: 0;
    margin-left: 0;
    text-align: center;
  }
	.timeline .list .timeline_ctnr .cont h5 {
    font-size: 15px;
		font-weight: 700;
  }
	.timeline .list .timeline_ctnr .cont p.date {
    font-size: 13px;
    font-weight: 800;
  }
	.timeline .list .timeline_ctnr .cont .loc {
    font-size: 14px;
		font-weight: 500;
		padding: 5px 0 7px;
    line-height: 1.1em;
  }
	.timeline .list .timeline_ctnr .cont .loc .flag {
    margin: 0 8px 0 0;
  }
  .timeline .list .timeline_ctnr .cont .badge {
    position: static;
    right: unset;
  }
  .timeline .list .timeline_ctnr .cont .live {
    height: 20px;
    margin: 10px 2px 0;
  }
	.timeline .list .timeline_ctnr .cont p:last-child {
    
  }
	.timeline .list .timeline_ctnr .cont p:before {
    width: 3px;
		height: 3px;
		left: 2px;
		top: 12px;
  }
	.timeline .list .timeline_ctnr .cont p.date:before {
    display: none;
  }
	.timeline .list .timeline_ctnr:hover,
	.timeline .list .timeline_ctnr:hover:after {
    background: #fff;
  }
  .timeline .list .timeline_ctnr .venue,
  .timeline .list .timeline_ctnr.am-eu .venue {
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 19vw;
    border-radius: 8px 8px 0 0;
    z-index: 0;
  }

	.timeline .list .no-results {
    padding: 60px 0;
  }
	.timeline .list .no-results p {
    font-size: 16.5px;
  }
	.timeline .list .no-results .reset {
    font-size: 15px;
    margin-top: 20px;
  }
	.timeline .list .no-results .reset:before {
    width: 12px;
    height: 20px;
  }
  .m-hide {
    display: none !important;
  }
  .list li span.p-hide {
    display: inline-block !important;
  }
</style>
